import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

// Icons
import SS from "@/assets/icons/motivators/spiffSetup/SS.svg";

const SpiffBonusView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Service Spiff Setup",
	headerIcon: SS,
	motivatorType: "spiffBonusSetup",
});

export default SpiffBonusView;
